import { Grid, Typography } from '@mui/material';
import { createUseStyles } from 'react-jss';
import { FC } from 'react';

interface InfoItemProps {
  itemName: string;
}

const useStyles = createUseStyles({
  container: {
    marginBottom: '18px',
  },
});

const InfoItem: FC<InfoItemProps> = (props) => {
  const classes = useStyles();
  return (
    <Grid className={classes.container}>
      <Typography variant="h3">{props.itemName}</Typography>
      <Grid>{props.children}</Grid>
    </Grid>
  );
};

export default InfoItem;
